export default __webpack_public_path__ + "static/media/entregascamiones.47507e9b.png";